import { render } from "./SearchItemAddress.vue?vue&type=template&id=cb0d5c62"
import script from "./SearchItemAddress.vue?vue&type=script&lang=ts"
export * from "./SearchItemAddress.vue?vue&type=script&lang=ts"
script.render = render

export default script